import Flag from "react-world-flags";
import { MODAL_STYLES } from "../../constants/modal-styles";

interface LanguageToggleProps {
  language: "ka" | "en";
  onLanguageChange: (lang: "ka" | "en") => void;
  className?: string;
}

export const LanguageToggle = ({
  language,
  onLanguageChange,
  className = "",
}: LanguageToggleProps) => {
  return (
    <div
      className={`flex justify-center text-base ${className}`}
      style={{
        fontFamily: MODAL_STYLES.fontFamily,
      }}
    >
      <div className="bg-amber-100 border-2 border-amber-800 rounded p-1 flex gap-1 items-center">
        <button
          onClick={() => onLanguageChange("ka")}
          className={`flex items-center justify-center gap-2 px-3 py-1.5 rounded transition-colors ${
            language === "ka"
              ? "bg-amber-800 text-white"
              : "bg-transparent hover:bg-amber-200"
          }`}
          title="ქართული"
        >
          <Flag
            code="GE"
            style={{
              width: "28px",
              height: "20px",
              borderRadius: "3px",
              objectFit: "cover",
            }}
          />
        </button>
        <button
          onClick={() => onLanguageChange("en")}
          className={`flex items-center justify-center gap-2 px-3 py-1.5 rounded transition-colors ${
            language === "en"
              ? "bg-amber-800 text-white"
              : "bg-transparent hover:bg-amber-200"
          }`}
          title="English"
        >
          <Flag
            code="GB"
            style={{
              width: "28px",
              height: "20px",
              borderRadius: "3px",
              objectFit: "cover",
            }}
          />
        </button>
      </div>
    </div>
  );
};
